var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFiveMedals = function SvgFiveMedals(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175.958,
    height: 126.008,
    viewBox: "0 0 175.958 126.008",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_237",
    "data-name": "Grupo 237",
    transform: "translate(-91.957 -99.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sombra",
    d: "M25.059,24.734c10.7,0,19.378,2.169,19.378,4.844s-8.677,4.844-19.378,4.844S5.681,32.252,5.681,29.578,14.359,24.734,25.059,24.734Z",
    transform: "translate(155.712 191.088)",
    fill: "rgba(31,26,23,0.2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_232",
    "data-name": "Grupo 232",
    transform: "translate(11.646 -69.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "estrela",
    transform: "translate(137.458 218.54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_666",
    "data-name": "Caminho 666",
    d: "M61.915,30.958A30.958,30.958,0,1,1,30.958,0,30.962,30.962,0,0,1,61.915,30.958Z",
    transform: "translate(-0.105 0.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "medal",
    d: "M33.187,60.095l-9.866,6.5L27.55,55.324l-8.456-5.638h9.866l4.228-11.275,4.228,11.275h9.866l-8.456,5.638L43.053,66.6l-9.866-6.5Z",
    transform: "translate(-2.198 -21.952)",
    fill: "#484643",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_233",
    "data-name": "Grupo 233",
    transform: "translate(-27.354 -61.498)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "estrela-2",
    "data-name": "estrela",
    transform: "translate(137.353 219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_666-2",
    "data-name": "Caminho 666",
    d: "M26.958,13.479A13.479,13.479,0,1,1,13.479,0,13.481,13.481,0,0,1,26.958,13.479Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "medal-2",
    "data-name": "medal",
    d: "M25.23,47.852l-4.3,2.832,1.841-4.909-3.682-2.455h4.3l1.841-4.909,1.841,4.909h4.3l-3.682,2.455,1.841,4.909-4.3-2.832Z",
    transform: "translate(-11.692 -31.445)",
    fill: "#484643",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_234",
    "data-name": "Grupo 234",
    transform: "translate(-45.396 -119.498)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "estrela-3",
    "data-name": "estrela",
    transform: "translate(137.353 219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_666-3",
    "data-name": "Caminho 666",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "medal-3",
    "data-name": "medal",
    d: "M25.922,48.918l-4.78,3.152,2.049-5.463-4.1-2.732h4.78l2.049-5.463,2.049,5.463h4.78l-4.1,2.732L30.7,52.07l-4.78-3.152Z",
    transform: "translate(-10.856 -30.659)",
    fill: "#484643",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_235",
    "data-name": "Grupo 235",
    transform: "translate(55.646 -109.498)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "estrela-4",
    "data-name": "estrela",
    transform: "translate(137.353 219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_666-4",
    "data-name": "Caminho 666",
    d: "M24.161,12.08A12.08,12.08,0,1,1,12.08,0,12.082,12.082,0,0,1,24.161,12.08Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "medal-4",
    "data-name": "medal",
    d: "M24.593,46.873l-3.85,2.538,1.65-4.4-3.3-2.2h3.85l1.65-4.4,1.65,4.4h3.85l-3.3,2.2,1.65,4.4-3.85-2.538Z",
    transform: "translate(-12.459 -32.168)",
    fill: "#484643",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_236",
    "data-name": "Grupo 236",
    transform: "translate(92.604 -78.498)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "estrela-5",
    "data-name": "estrela",
    transform: "translate(137.353 219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_666-5",
    "data-name": "Caminho 666",
    d: "M37.957,18.979A18.979,18.979,0,1,1,18.979,0,18.981,18.981,0,0,1,37.957,18.979Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "medal-5",
    "data-name": "medal",
    d: "M27.734,51.7l-6.048,3.988,2.592-6.912-5.184-3.456h6.048l2.592-6.912,2.592,6.912h6.048L31.19,48.78l2.592,6.912L27.734,51.7Z",
    transform: "translate(-8.671 -28.603)",
    fill: "#484643",
    fillRule: "evenodd"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFiveMedals, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/five_medals.4a2a358a.svg";
export { ForwardRef as ReactComponent };